import { Model } from "pinia-orm";

export default class Section extends Model {
  static entity = "sections";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      sectionNumber: this.attr(null),
      label: this.string(""),
      icpeClassification: this.string(""),
      observation: this.string(""),
    };
  }
}
